/** The steps of the guided setup, in the order they are done. */
export enum SetupStepId {
    Agreement = 'agreement',
    Kyc = 'kyc',
    BankAccount = 'bankAccount',
    Store = 'store',
    ApiKey = 'apiKey',
}

export const setupStepIds: SetupStepId[] = [
    SetupStepId.Agreement,
    SetupStepId.Kyc,
    SetupStepId.BankAccount,
    SetupStepId.Store,
    SetupStepId.ApiKey,
];

export enum SetupStepStatus {
    /** Nothing has been done yet, or the user is still busy with it. */
    NotStarted = 'not-started',
    /** The user has done their part; Walley or a signatory has to act next. */
    Waiting = 'waiting',
    Done = 'done',
    /** Declined or failed; it cannot be redone from the setup. */
    Failed = 'failed',
}

/**
 * Where each step stands, as answered by GET organizations/{id} (setupSteps). The backend reads everything from live
 * data, so a step done outside the setup (e.g. a store onboarded by Walley) counts as done too. It leaves the steps out
 * once every step is done.
 */
export type SetupSteps = Record<SetupStepId, SetupStepStatus>;
